import React from 'react';

import Logo from '../../assets/img/logo/loading-img.png';

const Preloader = () => {
  return (
    <div id="it-loading">
      <div id="it-loading-center">
        <div id="it-loading-absolute">
          <div className="it-loading-content">
            <img className="it-loading-logo" src={Logo} alt="" />
            <div className="it-loading-stroke">         
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Preloader;
